import camelCase from 'lodash/camelCase'

import { responsiveIndex } from '../../components/ThemeProvider/theme';

export default (q, active) => responsiveIndex.reduce((r, [i, name]) => {
  r[camelCase(`is-${name}`)] = active ? !q[i - 1] : false
  return r
}, {})
